import React from 'react';
import TextInput from '../shared/TextInput';
import Textarea from '../shared/Textarea';
import Button from '../shared/Button';
import './StageTwo.css';

const StageTwo = ({ formData, setFormData, onBack, onSubmit, isSubmitting }) => {
  const [errors, setErrors] = React.useState({});

  const handleChange = (field) => (e) => {
    setFormData({
      ...formData,
      provider_details: {
        ...formData.provider_details,
        [field]: e.target.value
      }
    });
    setErrors({ ...errors, [field]: null });
  };

  const validate = () => {
    const newErrors = {};
    const { name, background, experience } = formData.provider_details;

    if (!name || name.trim().length === 0) {
      newErrors.name = 'Name is required';
    }

    if (!background || background.trim().length === 0) {
      newErrors.background = 'Background is required';
    }

    if (!experience || experience.trim().length < 60) {
      newErrors.experience = 'Please provide at least 60 characters of relevant experience';
    }

    if (experience && experience.trim().length > 2000) {
      newErrors.experience = 'Experience must be less than 2000 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      onSubmit(formData);
    }
  };

  return (
    <div className="stage-two">
      <TextInput
        label="Name"
        value={formData.provider_details.name}
        onChange={handleChange('name')}
        placeholder="Your name"
        required
        error={errors.name}
      />

      <TextInput
        label="Background / Domain"
        value={formData.provider_details.background}
        onChange={handleChange('background')}
        placeholder="e.g., Financial analyst, Policy researcher, etc."
        required
        error={errors.background}
      />

      <Textarea
        label="Relevant Experience"
        value={formData.provider_details.experience}
        onChange={handleChange('experience')}
        placeholder="Describe your relevant experience and expertise..."
        required
        minLength={60}
        maxLength={2000}
        showCounter
        error={errors.experience}
        rows={5}
      />

      <div className="stage-two__actions">
        <Button onClick={onBack} variant="secondary" disabled={isSubmitting}>
          Back
        </Button>
        <Button onClick={handleSubmit} variant="primary" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </Button>
      </div>
    </div>
  );
};

export default StageTwo;
